import React, { useState } from "react";
import CustomInput from "../../components/CustomInput";
import CustomSelect from "../../components/CustomSelect";
import SubHeadings from "../../components/SubHeadings";

const Services = () => {
  const [inp, setInp] = useState("0");
  const [serviceType, setServiceType] = useState("0");
  return (
    <div className="grid grid-cols-2 p-8 gap-4">
      {/* Example: CustomInput */}
      <CustomInput
        name="slNo"
        value={inp}
        onChange={(e) => setInp(e.target.value)}
        type="text"
        label="SL. No."
        placeholder="SL. No."
      />

      {/* Example: CustomSelect */}
      <CustomSelect
        name="serviceType"
        value={serviceType}
        onChange={(e) => setServiceType(e.target.value)}
        label="Service Type"
        options={["Laundry", "Dry Cleaning", "Ironing"]}
      />

      {/* Subtitle */}
      <SubHeadings text="Some sub heading" />
    </div>
  );
};

export default Services;
